'use client';

import { For, SegmentGroup } from '@chakra-ui/react';
import * as React from 'react';

interface Item {
  value: string
  label: React.ReactNode
  disabled?: boolean
}

export interface SegmentedControlProps extends SegmentGroup.RootProps {
  items: Array<string | Item>
  fitted?: boolean
}

function normalize(items: Array<string | Item>): Item[] {
  return items.map((item) => {
    if (typeof item === 'string') return { value: item, label: item };
    return item;
  });
}

export const SegmentedControl = React.forwardRef<
HTMLDivElement,
SegmentedControlProps
>((props, ref) => {
  const {
    items,
    fitted,
    ...rest
  } = props;
  const data = React.useMemo(() => normalize(items), [items]);

  return (
    <SegmentGroup.Root ref={ref} {...rest} w={fitted ? '100%' : 'auto'}>
      <SegmentGroup.Indicator />
      <For each={data}>
        {(item) => (
          <SegmentGroup.Item
            key={item.value}
            value={item.value}
            disabled={item.disabled}
            width={fitted ? '100%' : 'auto'}
            mr={0}
            fontSize="inherit"
            _focus={{
              outline: 'none',
            }}
            _hover={{
              cursor: 'pointer',
            }}
          >
            <SegmentGroup.ItemText>{item.label}</SegmentGroup.ItemText>
            <SegmentGroup.ItemHiddenInput />
          </SegmentGroup.Item>
        )}
      </For>
    </SegmentGroup.Root>
  );
});
